import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "super-admin"
    }}>{`super admin`}</h2>
    <p>{`The super admin role in an e-commerce site holds ultimate control. They manage users, permissions, and critical settings, ensuring seamless operations and security at the highest level. `}</p>
    <p>{`As, super admin has the supreme authority over any vendor, so he/she can control any listed shops in the application. Here are the key notes for super admin,`}</p>
    <ul>
      <li parentName="ul">{`Super admin can see access all settings & menu.`}</li>
      <li parentName="ul">{`Super admin is also a vendor, staff, customer himself/herself. So, he/she can listed his own shop & control them as a vendor/staff/customer perspective.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      